<!-- Static sidebar for mobile -->
<el-dialog #elDialog>
  <dialog
    id="sidebar"
    class="backdrop:bg-transparent lg:hidden">
    <el-dialog-backdrop
      class="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"></el-dialog-backdrop>

    <div
      tabindex="0"
      class="fixed inset-0 flex focus:outline-none">
      <el-dialog-panel
        class="group/dialog-panel relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full">
        <div
          class="absolute top-0 left-full flex w-16 justify-center pt-5 duration-300 ease-in-out group-data-closed/dialog-panel:opacity-0">
          <button
            type="button"
            command="close"
            commandfor="sidebar"
            class="-m-2.5 p-2.5">
            <span class="sr-only">
              <ng-container i18n>Close sidebar</ng-container>
            </span>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              data-slot="icon"
              aria-hidden="true"
              class="size-6 text-white">
              <path
                d="M6 18 18 6M6 6l12 12"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>

        <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-2 ring-1 ring-white/10">
          @if(logo) {
          <div class="flex h-16 shrink-0 items-center">
            <img
              [src]="logo.src"
              [attr.alt]="logo.alt ? logo.alt : null"
              class="h-8 w-auto" />
          </div>
          }
          <nav class="flex flex-1 flex-col">
            <ul
              role="list"
              class="-mx-2 flex-1 space-y-1">
              @for (navItem of navList?.navItems; track $index) {
              <a
                [routerLink]="navItem.routerLink"
                (click)="hideMobileSidebar()"
                class="group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-400 hover:bg-gray-800 hover:text-white"
                routerLinkActive="bg-gray-800 text-white">
                <!-- Icon -->
                @if (navItem.icon) {
                <app-icon
                  [name]="navItem.icon"
                  type="outline"
                  class="shrink-0">
                </app-icon>
                }
                {{ navItem.textContent }}
              </a>
              }
            </ul>
          </nav>
        </div>
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>

<!-- Static sidebar for desktop -->
<div class="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:block lg:w-20 lg:overflow-y-auto lg:bg-gray-900 lg:pb-4">
  @if(logo) {
  <div class="relative flex h-16 shrink-0 items-center justify-center">
    <img
      [src]="logo.src"
      [attr.alt]="logo.alt ? logo.alt : null"
      class="h-8 w-auto" />
  </div>
  }
  <nav class="relative mt-8">
    <ul
      role="list"
      class="flex flex-col items-center space-y-1">
      @for (navItem of navList?.navItems; track $index) {
      <a
        [routerLink]="navItem.routerLink"
        class="group flex gap-x-3 rounded-md p-3 text-sm/6 font-semibold text-gray-400 hover:bg-white/5 hover:text-white"
        routerLinkActive="bg-white/5 text-white">
        <!-- Icon -->
        @if (navItem.icon) {
        <app-icon
          [name]="navItem.icon"
          type="outline"
          class="shrink-0">
        </app-icon>
        }
        <span class="sr-only">{{ navItem.textContent }}</span>
      </a>
      }
    </ul>
  </nav>
</div>

<div class="lg:pl-20">
  <div
    class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8">
    <button
      type="button"
      command="show-modal"
      commandfor="sidebar"
      class="-m-2.5 p-2.5 text-gray-700 lg:hidden">
      <span class="sr-only">
        <ng-container i18n>Open sidebar</ng-container>
      </span>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        data-slot="icon"
        aria-hidden="true"
        class="size-6">
        <path
          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <!-- Separator -->
    <div
      aria-hidden="true"
      class="h-6 w-px bg-gray-900/10 lg:hidden"></div>

    <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
      <div class="grid flex-1 grid-cols-1">
        <ng-content select="[app-narrow-sidebar-search]"></ng-content>
        <!-- <input
          name="search"
          type="search"
          placeholder="Search2"
          aria-label="Search"
          class="col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-none outline-hidden placeholder:text-gray-400 sm:text-sm/6" /> -->
        <svg
          viewBox="0 0 20 20"
          fill="currentColor"
          data-slot="icon"
          aria-hidden="true"
          class="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400">
          <path
            d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
            clip-rule="evenodd"
            fill-rule="evenodd" />
        </svg>
      </div>
      <div class="flex items-center gap-x-4 lg:gap-x-6">
        <button
          type="button"
          class="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
          <span class="sr-only">View notifications</span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            data-slot="icon"
            aria-hidden="true"
            class="size-6">
            <path
              d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>

        <!-- Separator -->
        <div
          aria-hidden="true"
          class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10"></div>

        <!-- Profile dropdown -->
        <ng-content select="app-narrow-sidebar-profile"></ng-content>
      </div>
    </div>
  </div>

  <main class="px-4 sm:px-6 lg:px-8 py-10">
    <div class="mx-auto max-w-7xl">
      <!-- Main area -->
      <ng-content></ng-content>
    </div>
  </main>
</div>

<!-- Content Children -->
<ng-template>
  <ng-content select="[app-narrow-sidebar-logo]"></ng-content>
</ng-template>
<ng-template>
  <ng-content select="app-narrow-sidebar-nav-list"></ng-content>
</ng-template>
